<template>
  <div>
    <p v-if="description" class="text-muted pb-2">{{ description }}</p>
    <AdminTableContainer
      :users="localUsers"
      :headers="headers"
      :options="options" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AdminTableContainer from '../../components/AdminTableContainer'

export default {
  name: 'UserMgmt',
  components: { AdminTableContainer },
  data() {
    return {
      headers: ['name', 'parents', 'email', 'phone'],
      localUsers: {},
      options: {
        sortable: true,
        actions: ['accountMgmt']
      },
      description: null
    }
  },
  methods: {
    ...mapActions(['getMyUsers', 'getUsers', 'getDescription'])
  },
  computed: {
    ...mapGetters(['users', 'getMyInfo'])
  },
  mounted: async function() {
    if (this.getMyInfo.hasRoles) {
      await this.getUsers({})
    } else {
      const obj = await this.getDescription()
      this.description = obj.user
      await this.getMyUsers({})
    }
    this.localUsers = this.users
  },
  watch: {
    users: {
      handler: function () {
        this.localUsers = this.users
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/Pages/UserMgmt/UserMgmt.vue?9911d8fc